import { useSelector } from 'react-redux';
import css from './CustomCarousel.module.css';
import { IconSpinner, NamedLink } from '../../../../components';
import ListingCarousel from './ListingCarousel/ListingCarousel';
import classNames from 'classnames';
import {
  customInProgressSelector,
  customListingsSelector,
} from '../../../LandingPage/LandingPage.duck';
import IconCard from '../../../../components/SavedCardDetails/IconCard/IconCard';
import { FormattedMessage } from 'react-intl';
import { useViewportSize } from '../../../../hooks';

const DEFAULT_SLIDES_TO_SHOW = 4;

function CustomCarousel(props) {
  const { sectionId, numColumns, isInsideContainer } = props;

  const viewportSize = useViewportSize();

  const listings = useSelector(state => customListingsSelector(state, sectionId));
  const progress = useSelector(state => customInProgressSelector(state, sectionId));
  const isFeatured = sectionId === 'featured-listings' || sectionId?.includes('featured-listings');
  const hasItems = (listings?.length || 0) > 0;
  const inProgress = progress;
  const slidesToShow = Math.min(numColumns ?? DEFAULT_SLIDES_TO_SHOW, listings.length);
  const showDots = viewportSize.width < 600;

  return (
    <section className={css.listingCards}>
      {inProgress ? (
        <div className={css.loadingContainer}>
          <IconSpinner />
        </div>
      ) : hasItems ? (
        <div
          className={classNames(css.carouselContainer, {
            [css.noSidePaddings]: isInsideContainer,
          })}
        >
          <div className={css.listingHeading}>
            <div className={css.title}>
              <FormattedMessage
                id={isFeatured ? 'home.featurelistingheading' : 'home.newlistingHeading'}
              />
            </div>

            <div className={css.desktopViewAllBtn}>
              {isFeatured ? (
                <NamedLink
                  className={css.viewAllBtn}
                  name="SearchPage"
                  to={{ search: '?pub_featured=true' }}
                >
                  <FormattedMessage id={'home.featurelistingBtnText'} />{' '}
                  <IconCard brand="rightArrow" />
                </NamedLink>
              ) : (
                <NamedLink className={css.viewAllBtn} name="SearchPage">
                  <FormattedMessage id={'home.newlistingBtnText'} /> <IconCard brand="rightArrow" />
                </NamedLink>
              )}
            </div>
          </div>
          <div className={css.carouselWrapper}>
            <ListingCarousel
              id={`${sectionId}-carousel`}
              listings={listings}
              slidesToShow={slidesToShow}
              showArrows={listings.length > slidesToShow}
              showDots={showDots}
              autoplay={false}
              emblaSettings={{ loop: false, align: 'start' }}
            />
          </div>

          <div className={css.mobileViewAllBtn}>
            {isFeatured ? (
              <NamedLink
                className={css.viewAllBtn}
                name="SearchPage"
                to={{ search: '?pub_featured=true' }}
              >
                <FormattedMessage id={'home.featurelistingBtnText'} />{' '}
                <IconCard brand="rightArrow" />
              </NamedLink>
            ) : (
              <NamedLink className={css.viewAllBtn} name="SearchPage">
                <FormattedMessage id={'home.newlistingBtnText'} /> <IconCard brand="rightArrow" />
              </NamedLink>
            )}
          </div>
        </div>
      ) : null}
    </section>
  );
}

export default CustomCarousel;
